
import React from 'react';
import { COMPARISONS } from '../constants';

const SeniorVsJunior: React.FC = () => {
  return (
    <section className="py-20 px-6 bg-slate-900/50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-3xl font-bold mb-4">The Mindset Shift</h2>
          <p className="text-slate-400 max-w-2xl mx-auto">
            What senior AWS engineers do differently. It's not about knowing more CLI flags, 
            it's about owning the outcomes.
          </p>
        </div>

        <div className="space-y-4">
          {COMPARISONS.map((comp, i) => (
            <div key={i} className="grid grid-cols-1 md:grid-cols-12 border border-slate-800 rounded-xl overflow-hidden">
              <div className="md:col-span-2 bg-slate-800/50 p-6 flex items-center font-bold text-orange-400">
                {comp.topic}
              </div>
              <div className="md:col-span-5 p-6 border-t md:border-t-0 md:border-l border-slate-800 bg-red-500/5">
                <div className="text-xs uppercase font-mono text-red-400 mb-2">Ticket-Driven (Junior)</div>
                <p className="text-slate-300 italic">"{comp.junior}"</p>
              </div>
              <div className="md:col-span-5 p-6 border-t md:border-t-0 md:border-l border-slate-800 bg-green-500/5">
                <div className="text-xs uppercase font-mono text-green-400 mb-2">System-Driven (Senior)</div>
                <p className="text-slate-100 font-medium">"{comp.senior}"</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default SeniorVsJunior;
